/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - CSS
 */
import '../Dropdown/styles/Dropdown.css'

/**
 *     Import
 *     - Icons
 */
import { DropdownArrowIcon } from '../../../images/icons/DropdownArrow/DropdownArrow'

/**
 * Dropdown component
 * @param  {array}     itemList    [array of objects with value and text for each option {'value', 'text'}]
 * @param  {string}    label       [Item label]
 */
export class SearchSelect extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.state = {
            open: false,
            active: false,
            selected: ['', ''],
            searchSelect: false,
            searchItem: null,
            initialItems: this.props.itemList,
            items: [],
        }
    }
    componentWillMount() {
        if (this.props.selected !== undefined) {
            this.setState({ selected: this.props.selected })
            this.props.setFieldValue(this.props.name, this.props.selected[0])
        }
        this.setState({ items: this.state.initialItems })
    }

    filterList = (event) => {
        var updatedList = this.state.initialItems
        updatedList = updatedList.filter((item, i) => {

            var getLenth = (event.target.value).length
            return (event.target.value).toLowerCase() === ((item.text).substring(0, getLenth)).toLowerCase()
        })
        this.setState({ items: updatedList })
    }

    toggleList = () => {
        if (!this.props.disableDropdown) {
            this.setState({ open: !this.state.open })
        }
    }

    selectItem = (item: any) => {
        this.setState({ selected: item })
        this.props.setFieldValue(this.props.name, item[0])
        this.toggleList()
        this.setState({ active: true })
    }

    handleClickOutside = (evt) => {
        if (this.state.open) {
            this.toggleList()
        }
    }

    formatState(state: any) {
        if (!state.id) {
            return state.text
        }
        var $state
        this.props.itemList.map((item, i) => (
            $state =
            <span>{state.text}</span>
        ))

        return $state
    }
    SearchItem = (e) => {
        this.setState({ SearchItem: e.target.value })
    }

    render() {

        const { itemList, label, labelShow = true, searchPlaceholder = 'Search Country', customCls = '' } = this.props

        let listStyles = {
            height: (this.state.open) ? '200px' : '0px',
        }

        return (
            <div className={`dropdown${(this.state.open) ? ' open' : ''} ${customCls}`}>
                {labelShow && <div className={`dropdown__label${(this.state.active) ? ' active' : ''}`}>{label}</div>}
                <div
                    className={`dropdown__selected ${(itemList.length < 1) ? 'disabled' : ''}`}
                    onClick={this.toggleList}
                >
                    <span>{(this.state.selected[1] !== '') ? this.state.selected[1] : label}</span>
                    {!this.props.disableDropdown ? <DropdownArrowIcon color={'#fca61b'} /> : null}
                </div>
                <div
                    className="dropdown__list"
                    style={listStyles}
                >
                    <span className="select2-search select2-search--dropdown">
                        <input
                            className="select2-search__field"
                            type="search"
                            role="searchbox"
                            aria-autocomplete="list"
                            placeholder={searchPlaceholder}
                            // onChange={(e) => this.SearchItem(e)}
                            onChange={this.filterList}
                        />
                    </span>
                    {(this.state.items.length !== null && this.state.items.length !== 0) ?
                        <div>
                            {this.state.items.map((item, i) => (
                                <div
                                    key={i}
                                    className="dropdown__item"
                                    data-category={item.value}
                                    onClick={(e) => this.selectItem([item.value, item.text])}
                                >
                                    {item.text}
                                </div>
                            ))}
                        </div>
                        : <div
                            className="dropdown__item"
                        >
                            {'No Data Found'}
                        </div>
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/SearchSelect/SearchSelect.tsx